// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Mozambique from '../_raw/flag/icon_flag_mozambique.png';

export default () => <img src={Mozambique} alt="Mozambique" />;
